import { render, staticRenderFns } from "./ParticipationRecords.vue?vue&type=template&id=a2c68e6c&scoped=true"
import script from "./ParticipationRecords.vue?vue&type=script&lang=js"
export * from "./ParticipationRecords.vue?vue&type=script&lang=js"
import style0 from "./ParticipationRecords.vue?vue&type=style&index=0&id=a2c68e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c68e6c",
  null
  
)

export default component.exports